var map = {
	"./clipboard.svg": "4533",
	"./computer.svg": "653e",
	"./email-clients.svg": "b9b3",
	"./external-drives.svg": "0c6f",
	"./file-upload.svg": "5216",
	"./files.svg": "45ad",
	"./hardware-changes.svg": "b6fe",
	"./installed-programs.svg": "d10d",
	"./keyboard.svg": "d035",
	"./messengers.svg": "08c7",
	"./mic-records.svg": "cc12c",
	"./network-accesses.svg": "d0ee",
	"./network-files.svg": "22e7",
	"./printer.svg": "248f",
	"./programs.svg": "d7f9",
	"./screenshots.svg": "92b4",
	"./search-queries.svg": "c879",
	"./shadow-copyings.svg": "f08e",
	"./social-networks.svg": "0e0d",
	"./visited-sites.svg": "dbc5",
	"./web-mail.svg": "c1ef",
	"./webcams-and-microphones.svg": "8af3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b78";